import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'baremetal' },
  path: 'baremetal/create',
  name: 'baremetal/create',
  component: () => import('@/views/dashboard/baremetal/create/create.vue'),
} satisfies RouteRecordRaw;
